export default __webpack_public_path__ + "static/media/SCANDIT.235baeab.png";